import { render, staticRenderFns } from "./collaborators-pullup.vue?vue&type=template&id=65fd4582&scoped=true"
import script from "./collaborators-pullup.ts?vue&type=script&lang=ts&external"
export * from "./collaborators-pullup.ts?vue&type=script&lang=ts&external"
import style0 from "./collaborators-pullup.scss?vue&type=style&index=0&id=65fd4582&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65fd4582",
  null
  
)

export default component.exports